export enum ProjectStatusCategory {
  ACTIVE,
  PENDING,
  SOLD,
}

export const ProjectStatusCategoryValues: string[] = ["ACTIVE", "PENDING", "SOLD"];

export const ProjectStatusCategoryData: { name: string; value: number }[] = [
  { name: "PENDING", value: ProjectStatusCategory.PENDING },
  { name: "ACTIVE", value: ProjectStatusCategory.ACTIVE },
  { name: "SOLD", value: ProjectStatusCategory.SOLD },
];

export const getProjectStatusSeverity = (status: ProjectStatusCategory): string => {
  if (status === ProjectStatusCategory.PENDING) return "warning";
  else if (status === ProjectStatusCategory.ACTIVE) return "success";
  else if (status === ProjectStatusCategory.SOLD) return "info";
  return "";
};

export const statusIsType = (status: string, category: number): boolean => {
  if (status === "ACTIVE" && category == ProjectStatusCategory.ACTIVE) {
    return true;
  } else if (status == "PENDING" && category == ProjectStatusCategory.PENDING) {
    return true;
  } else if (status == "SOLD" && category == ProjectStatusCategory.SOLD) {
    return true;
  }
  return false;
};

export const getStatusFromString = (status: string): ProjectStatusCategory | null => {
  if (status === "ACTIVE") {
    return ProjectStatusCategory.ACTIVE;
  } else if (status == "PENDING") {
    return ProjectStatusCategory.PENDING;
  } else if (status == "SOLD") {
    return ProjectStatusCategory.SOLD;
  }

  return null;
};
